var map = {
	"./vab-blue-variables.scss": "./src/vab/styles/variables/vab-blue-variables.scss",
	"./vab-green-variables.scss": "./src/vab/styles/variables/vab-green-variables.scss",
	"./vab-purple-variables.scss": "./src/vab/styles/variables/vab-purple-variables.scss",
	"./vab-red-variables.scss": "./src/vab/styles/variables/vab-red-variables.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/vab/styles/variables sync recursive ^\\.\\/vab\\-.*\\-variables\\.scss$";